module.exports = __webpack_public_path__ + "media/images/service/bg-fae43bb40a7eaac930ad7b052ebd4cfc.png";